// Espelha ChaveEtapaKanbanEnum no backend (coluna etapa_kanban.chave).
//
// A chave e a identidade estavel da etapa semeada pelo sistema: o usuario renomeia o `nome`
// a vontade, mas a chave nunca muda, e e por ela que o codigo localiza "o Separacao desta
// empresa" sem depender do texto exibido. Etapa criada pelo usuario tem chave null.
//
// Enum de STRING de proposito: o banco persiste o texto, nao um id. No backend o mesmo enum
// existe sem valor numerico e e usado via nameof.
export enum ChaveEtapaKanbanEnum {
    Modelo = 'Modelo',
    EmAberto = 'EmAberto',
    Aprovado = 'Aprovado',
    Recusado = 'Recusado',
    Cancelado = 'Cancelado',
    Entregue = 'Entregue',
    NaoEntregue = 'NaoEntregue',
    Separacao = 'Separacao',
    Expedicao = 'Expedicao',
}
